import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("travele_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function rupiah(n) {
  if (n == null) return "-";
  return "Rp" + Number(n).toLocaleString("id-ID");
}

export const WA_ADMIN = "628112828852";

export const slugify = (t) => (t || "").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path.startsWith("/") ? "" : "/"}${path}`;
}

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data.url;
}

export const STATUS_LABELS = {
  order_baru: "Order Baru",
  menunggu_verifikasi_admin: "Menunggu Verifikasi Admin",
  menunggu_konfirmasi_driver: "Menunggu Konfirmasi Driver",
  driver_tersedia: "Driver Tersedia",
  driver_tidak_tersedia: "Driver Tidak Tersedia",
  menunggu_pembayaran: "Menunggu Pembayaran",
  pembayaran_sebagian: "Pembayaran Sebagian",
  pembayaran_lunas: "Pembayaran Lunas",
  terkonfirmasi: "Terkonfirmasi",
  penjemputan: "Penjemputan",
  dalam_perjalanan: "Dalam Perjalanan",
  selesai: "Selesai",
  dibatalkan_penumpang: "Dibatalkan Penumpang",
  dibatalkan_driver: "Dibatalkan Driver",
  dibatalkan_admin: "Dibatalkan Admin",
  pengembalian_dana: "Pengembalian Dana",
  sengketa: "Sengketa",
  kadaluarsa: "Kadaluarsa",
};
